import { usePathname } from 'next/navigation';

const EXCEPTIONS_PATHNAMES = ['/festival/landing', '/card/landing'];

export const useCheckAutoLoginBottomSheetExceptions = () => {
  const pathname = usePathname();

  const isExceptionPath = pathname
    ? EXCEPTIONS_PATHNAMES.includes(pathname)
    : false;

  return {
    isExceptionPath,
  };
};
